import styled, { keyframes } from "styled-components";

const slideIn = keyframes`
  from { transform: translateX(100%); }
  to   { transform: translateX(0); }
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 300;
  display: flex;
  justify-content: flex-end;
`;

export const Panel = styled.div`
  width: 480px;
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  animation: ${slideIn} 0.22s ease;
  box-shadow: -4px 0 32px rgba(0, 0, 0, 0.12);
`;

export const PanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 28px;
  border-bottom: 1px solid #f0f0f0;
  flex-shrink: 0;
`;

export const PanelTitle = styled.h2`
  font-size: 18px;
  font-weight: 800;
  color: #111;
  letter-spacing: -0.02em;
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const EditButton = styled.button`
  height: 32px;
  padding: 0 14px;
  border: none;
  border-radius: 8px;
  background-color: #1fbc70;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.15s;

  &:hover { background-color: #18a360; }
`;

export const CloseButton = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: none;
  background-color: #f5f5f5;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #555;
  transition: background-color 0.15s;

  &:hover { background-color: #ebebeb; }
`;

export const PanelBody = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 24px 28px;
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

/* ── 수정 폼 ── */

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const FormLabel = styled.label`
  font-size: 12px;
  font-weight: 600;
  color: #666;
`;

export const FormInput = styled.input`
  height: 36px;
  padding: 0 12px;
  border: 1.5px solid #e8e8e8;
  border-radius: 8px;
  font-size: 13px;
  color: #111;
  background-color: #fff;
  box-sizing: border-box;
  width: 100%;
  transition: border-color 0.15s;

  &::placeholder { color: #bbb; }
  &:focus { outline: none; border-color: #1fbc70; }
  &:disabled { opacity: 0.6; }
`;

export const FormActions = styled.div`
  display: flex;
  gap: 10px;
  padding-top: 8px;
  border-top: 1px solid #f0f0f0;
  margin-top: auto;
`;

export const SaveButton = styled.button`
  flex: 1;
  height: 42px;
  border: none;
  border-radius: 10px;
  background-color: #1fbc70;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.15s;

  &:hover:not(:disabled) { background-color: #18a360; }
  &:disabled { opacity: 0.6; cursor: not-allowed; }
`;

export const CancelButton = styled.button`
  flex: 1;
  height: 42px;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  background-color: #fff;
  color: #555;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s;

  &:hover:not(:disabled) { background-color: #f5f5f5; }
  &:disabled { opacity: 0.6; cursor: not-allowed; }
`;

/* ── 시설 목록 ── */

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SectionLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SectionTitle = styled.p`
  font-size: 12px;
  font-weight: 700;
  color: #888;
  letter-spacing: 0.06em;
  text-transform: uppercase;
`;

export const CountBadge = styled.span`
  display: inline-block;
  padding: 1px 8px;
  background-color: #f0fdf7;
  border: 1px solid #d0f0e0;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  color: #1fbc70;
`;

export const AddButton = styled.button`
  height: 30px;
  padding: 0 12px;
  background-color: #1fbc70;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.15s;

  &:hover { background-color: #18a860; }
`;

export const RemoveButton = styled.button`
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  border: 1px solid #f0d0d0;
  background-color: #fff5f5;
  color: #fc324a;
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.15s;

  &:hover { background-color: #ffe0e0; }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
`;

export const StatusText = styled.p`
  text-align: center;
  font-size: 13px;
  color: #bbb;
  padding: 40px 0;
`;

export const EmptyWrap = styled.div`
  border: 1px dashed #eee;
  border-radius: 12px;
  padding: 40px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const EmptyText = styled.p`
  font-size: 13px;
  color: #bbb;
`;

export const FacilityList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FacilityCard = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  background-color: #fff;
  transition: background-color 0.12s;

  &:hover { background-color: #fafff9; }
`;

export const FacilityThumb = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 10px;
  object-fit: cover;
  flex-shrink: 0;
  background-color: #f0f0f0;
`;

export const FacilityThumbPlaceholder = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 10px;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  flex-shrink: 0;
`;

export const FacilityInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const FacilityName = styled.p`
  font-size: 14px;
  font-weight: 600;
  color: #111;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const FacilityMeta = styled.p`
  font-size: 12px;
  color: #aaa;
  margin-top: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
